import React from "react"
import { AppPillToggle } from "@components"


export default function SearchAnalyticsCustomTableToolbar({ showDateTable, setShowDateTable }) {

	return <AppPillToggle
		sx={{ mt: 1.5 }}
		value={showDateTable ? 'date' : 'site'}
		options={[
			{ value: 'site', label: 'User & Site' },
			{ value: 'date', label: 'Date & User' },
		]}
		onChange={view => setShowDateTable({ target: { checked: view === 'date' } })}
	/>
}
